import { render, staticRenderFns } from "./ac-custom-header.vue?vue&type=template&id=4a5062ff&"
import script from "./ac-custom-header.vue?vue&type=script&lang=js&"
export * from "./ac-custom-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports